import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueCompositionAPI from "@vue/composition-api"
import { debounce } from "lodash"

import 'normalize.css';

Vue.config.productionTip = false
Vue.use(VueCompositionAPI)

const requireComponent = require.context(
  "./components",
  false,
  /Base[A-Z]\w+\.(vue|js)$/
);

requireComponent.keys().forEach((fileName) => {
  const componentConfig = requireComponent(fileName);

  const componentName = upperFirst(
    camelCase(fileName.replace(/^\.\/(.*)\.\w+$/, "$1"))
  );

  Vue.component(componentName, componentConfig.default || componentConfig);
});

const handleResize = () => {
  // console.log("handleResize()");
  let vh = window.innerHeight * 0.01;
  // Then we set the value in the --vh custom property to the root of the document
  document.documentElement.style.setProperty('--vh', `${vh}px`);
}

window.addEventListener("resize", debounce(() => {
  handleResize();
}, 300))

handleResize();

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

import gsap from "gsap";
import { CSSPlugin } from "gsap/all"
// const plugins = [CSSPlugin];
gsap.registerPlugin(CSSPlugin)
window.gsap = gsap;
